import styled, { keyframes } from 'styled-components'
import { Container } from '../../styles/global'

export const Wrapper = styled(Container)`
  z-index: -1;
`